export class ApplicationResponseModel {
    constructor(
      public code: string    
    ) {}
  }